import type { FunctionComponent } from 'react';
import React from 'react';

import { ApolloProvider } from '@trello/graphql';
import { ReduxProvider } from 'app/src/components/ReduxProvider';
import { TrelloIntlProvider } from '@trello/i18n/provider';

export const ComponentWrapper: FunctionComponent = ({ children }) => {
  return (
    <div className="js-react-root">
      <TrelloIntlProvider>
        <ApolloProvider>
          <ReduxProvider>{children}</ReduxProvider>
        </ApolloProvider>
      </TrelloIntlProvider>
    </div>
  );
};
